import {
	type OrderDetailResponseDto,
	OrderStatus,
} from "Infrastructure/Api/Api";
import { isCallOutcomeOpenAtom } from "Order/Atom/callOutcomeOpen";
import { ActionsMenu } from "Order/Components/Actions/ActionsMenu";
import { StartAllocationFlowButton } from "Order/Components/Actions/StartAllocationFlowButton";
import { ExpandMore, Phone } from "@mui/icons-material";
import { Button, ButtonGroup, Stack } from "@mui/material";
import { useAtom } from "jotai";
import { useRef, useState } from "react";
import { OrderCallsList } from "../Lists/OrderCallsList";

type OrderActionButtonsProps = {
	order?: OrderDetailResponseDto;
};

export function OrderActionButtons({ order }: OrderActionButtonsProps) {
	const [orderCallsListOpen, setOrderCallsListOpen] = useState<boolean>(false);
	const callsListButton = useRef<HTMLButtonElement | null>(null);
	const [isCallOutcomeOpen, setIsCallOutcomeOpen] = useAtom(
		isCallOutcomeOpenAtom,
	);

	const openCallOutcomeDialog = () => {
		setIsCallOutcomeOpen(!isCallOutcomeOpen);
	};

	return (
		<Stack
			direction="row"
			gap={1}
			alignItems="center"
			justifyContent={{ xs: "flex-end", sm: "flex-start" }}
		>
			<ButtonGroup>
				<Button
					onClick={openCallOutcomeDialog}
					disabled={!order?.customer.phone}
					size="small"
					sx={{
						maxHeight: 40,
						maxWidth: 40,
						"&:hover": {
							border: "none !important",
						},
					}}
				>
					<Phone />
				</Button>
				<Button
					size="small"
					ref={callsListButton}
					onClick={() => setOrderCallsListOpen(!orderCallsListOpen)}
					disabled={order?.calls.length === 0}
					sx={{
						maxHeight: 40,
						maxWidth: 40,
						"&:hover": {
							border: "none !important",
						},
					}}
				>
					<ExpandMore />
				</Button>
			</ButtonGroup>

			<OrderCallsList
				open={orderCallsListOpen}
				anchorEl={callsListButton.current}
				onClose={() => setOrderCallsListOpen(false)}
				order={order}
			/>

			{order?.status === OrderStatus.confirmed && (
				<StartAllocationFlowButton orderId={order.id} />
			)}

			{order && <ActionsMenu order={order} />}
		</Stack>
	);
}
